
import { mdiClose, mdiMenuDown } from "@mdi/js";
import { spacesToDashes } from "~/common/helpers";

export default {
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
      // isFull: false,
      initServicesCount: 10,
      mdiClose,
      mdiMenuDown,
    };
  },

  computed: {
    dialogProps() {
      if (
        this.$device.isMobile ||
        (typeof window !== "undefined" && window.innerWidth < 993)
      ) {
        return {
          scrollable: true,
          transition: "dialog-bottom-transition",
          contentClass: "services-dialog__content",
        };
      } else {
        return {
          maxWidth: 860,
          transition: "dialog-transition",
          contentClass: "services-dialog__content",
        };
      }
    },

    services() {
      return this.profile?.services || [];
    },

    // servicePaginated() {
    //   return this.services.slice(
    //     0,
    //     this.isFull ? this.services.length : this.initServicesCount
    //   );
    // },
  },

  methods: {
    open() {
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
    },

    tagToUrl(tag, queryParamName) {
      const gender = this.profile.gender.toLocaleLowerCase();
      const cityUrl = spacesToDashes(this.profile.location[0].baseCity);

      return queryParamName
        ? `/${cityUrl}/${gender}?${queryParamName}=${tag}`
        : `/${cityUrl}/${gender}/${tag}`;
    },
  },
};
